import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  selectedTab: 0,
  selectedButton: "",
  selectedCategory: "",
  selectedControlType: "",
  row_id: "",
};

const tabSelectedSlice = createSlice({
  name: "tabSelected",
  initialState,
  reducers: {
    setTabSelected(state, action: PayloadAction<number>) {
      state.selectedTab = action.payload;
    },
    setButtonSelected(state, action: PayloadAction<string>) {
      state.selectedButton = action.payload;
      // A label set on its own (e.g. a row click) must not inherit the previous
      // tab's category; TabSelection sets the category right after the label.
      state.selectedCategory = "";
    },
    setCategorySelected(state, action: PayloadAction<string>) {
      state.selectedCategory = action.payload;
    },
    setSelectedCategory(state, action: PayloadAction<string>) {
      state.selectedCategory = action.payload;
    },
    setSelectedControlType(state, action: PayloadAction<string>) {
      state.selectedControlType = action.payload;
    },
    setSelectedRowID(state, action: PayloadAction<string>) {
      state.row_id = action.payload;
    },
  },
});

export const {
  setTabSelected,
  setButtonSelected,
  setCategorySelected,
  setSelectedCategory,
  setSelectedControlType,
  setSelectedRowID,
} = tabSelectedSlice.actions;
export default tabSelectedSlice.reducer;
